module.exports = __webpack_public_path__ + "img/warehousingentryselected.320f5d16.jpg";